export function signInRequest(user, password) {
  return {
     type: '@auth/SIGN_IN_REQUEST',
     payload: { user, password}
  }
}

export function signInSuccess(token, user){
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user}
  }
}

export function signUpSuccess(token, user){
  return {
    type: '@auth/SIGN_UP_SUCCESS',
    payload: { token, user}
  }
}

export function signUpRequest(user, email, password){
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: {
      user,
      email,
      password,
    }
  }
}

export function signFailure(){
  return {
    type: '@auth/SIGN_FAILURE',
  }
}

export function signUpFailure(){
  return {
    type: '@auth/SIGN_UP_FAILURE',
  }
}

export function signOut(){
  return {
    type: '@auth/SIGN_OUT',
  }
}

export function signInExpired(){
  return {
    type: '@auth/SIGN_IN_EXPIRED',
  }
}
